module.exports = __webpack_public_path__ + "static/media/edit-3-white.feb18887.svg";